module.exports = __webpack_public_path__ + "img/dashboard-landing-area-filter.52d9d9c5.svg";